"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _services = require("../../../services");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _CustomIconOrImage = _interopRequireDefault(require("../../shared/CustomIconOrImage"));
var _useConfig = _interopRequireDefault(require("../../../hooks/useConfig"));
var _useLocalTheme = _interopRequireDefault(require("../../../hooks/useLocalTheme"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Container = (0, _styledComponents.default)('div')(props => (0, _styledComponents.css)`
    & [class*='ContainerWithLabelstyle__LabelContainer'] {
      background-color: ${props === null || props === void 0 ? void 0 : props.bgColor};
      display: flex;
      justify-content: flex-start;
      & p {
        color: ${props === null || props === void 0 ? void 0 : props.color};
        font-weight: ${props === null || props === void 0 ? void 0 : props.fontWeight};
      }
    }
    & [class*='Interactionstyle__BlankInteraction']::after {
      content: ' ';
      border-color: ${props === null || props === void 0 ? void 0 : props.borderColor};
    }
    & [class*='ContainerWithLabelstyle__Header'] {
      height: max-content;
    }
    & p {
      overflow: visible;
      white-space: normal;
      padding: 8px 0;
    }
  `);
const TextContainer = _styledComponents.default.div`
  margin-left: -4%;
`;
const IconContainer = _styledComponents.default.div`
  padding-top: 8px;
`;
const RefurbishedProduct = _ref => {
  let {
    handsetIndex
  } = _ref;
  const refurbishedPolicy = (0, _useConfig.default)('refurbishedPolicy', []);
  const containerWithLabelStyle = (0, _useLocalTheme.default)(`recommendation.containerWithLabelStyle`, null);
  const hasElevation = (0, _useLocalTheme.default)(`hasElevation`, true);
  return refurbishedPolicy.length ? /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 3
    }
  }, /*#__PURE__*/_react.default.createElement(Container, _extends({
    "data-test-id": `refurbished-title-${handsetIndex}`
  }, containerWithLabelStyle), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.ContainerWithLabel, {
    label: `${_services.Services.locale.localeString('Refurbished.title')}`,
    level: 2,
    paddingLevel: 3,
    appearance: "secondary",
    elevation: hasElevation
  }, refurbishedPolicy.map((el, index) => {
    var _el$icon, _el$icon2, _el$icon3, _el$icon4;
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
      key: index
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SimpleGrid, {
      layout: {
        sm: [2, 10],
        md: [1, 11]
      },
      verticalAlign: "top"
    }, /*#__PURE__*/_react.default.createElement(IconContainer, null, /*#__PURE__*/_react.default.createElement(_CustomIconOrImage.default, {
      name: (_el$icon = el.icon) === null || _el$icon === void 0 ? void 0 : _el$icon.name,
      src: {
        sm: (_el$icon2 = el.icon) === null || _el$icon2 === void 0 ? void 0 : _el$icon2.image,
        md: (_el$icon3 = el.icon) === null || _el$icon3 === void 0 ? void 0 : _el$icon3.image,
        lg: (_el$icon4 = el.icon) === null || _el$icon4 === void 0 ? void 0 : _el$icon4.image
      },
      state: "success",
      group: "system",
      iconWidth: "25px",
      iconHeight: "25px",
      size: 3,
      testId: `refurbished-features-icons-${index}-${handsetIndex}`
    })), /*#__PURE__*/_react.default.createElement(TextContainer, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
      dataAttributes: {
        'data-test-id': `refurbished-features-${index}-${handsetIndex}`
      }
    }, _services.Services.locale.localeString(`Refurbished.${el.key}`)))), index < refurbishedPolicy.length - 1 && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Divider, null));
  })))) : null;
};
var _default = RefurbishedProduct;
exports.default = _default;